// Route-level error boundary. A render crash in one page must degrade to a
// friendly card, never a blank white app (which is what happened when the
// My Store fleet map threw on an unexpected response shape, PR #26).

import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class RouteErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error) {
    // Surface in the console for debugging; there is no telemetry sink yet.
    console.error('[route-error-boundary]', error);
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto w-full max-w-lg pb-24">
        <div className="rounded-xl border border-candy-line bg-candy-white px-4 py-8 text-center shadow-1 dark:border-candy-dark-line dark:bg-candy-dark-surface">
          <p className="mb-1 text-[15px] font-semibold text-candy-ink dark:text-candy-dark-ink">
            Something went wrong on this page.
          </p>
          <p className="mb-4 text-sm text-candy-ink-muted dark:text-candy-dark-ink-muted">
            The rest of the site is fine. You can go back home or try this page again.
          </p>
          <div className="flex justify-center gap-2">
            <a
              href="/"
              className="rounded-md border border-candy-line px-3 py-1.5 text-sm font-medium text-candy-ink hover:border-candy-pink dark:border-candy-dark-line dark:text-candy-dark-ink dark:hover:border-candy-pink-dark"
            >
              Home
            </a>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-md bg-candy-pink px-3 py-1.5 text-sm font-medium text-white hover:opacity-90 dark:bg-candy-pink-dark dark:text-candy-dark-bg"
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    );
  }
}
